import React, { useEffect, useState } from 'react';
import Snackbar from '../Snackbar/Snackbar';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import useParticipantsContext from '../../hooks/useParticipantsContext/useParticipantsContext';
import { ANIMATION_DURATION } from '../Buttons/ToggleChatButton/ToggleChatButton';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { useAppState } from '../../state';

export default function ParticipantActivityNotification() {
  const { speakerViewParticipants } = useParticipantsContext();
  const [participants, setParticipants] = useState<string[]>([]);
  const [participantActivity, setParticipantActivity] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [isFirstTime, setIsFirstTime] = useState(true);
  const { notificationSound } = useAppState();

  useEffect(() => {
    const identities = speakerViewParticipants.map(e => e.identity);

    if (identities.length > participants.length && !isFirstTime) {
      const diff = identities.filter(x => !participants.includes(x));
      notificationSound.play();
      setParticipantActivity(diff.join(', ') + ' belépett.');
      setShowMessage(true);
      setTimeout(() => setShowMessage(false), 3000);
    } else if (identities.length < participants.length) {
      const diff = participants.filter(x => !identities.includes(x));
      notificationSound.play();
      setParticipantActivity(diff.join(', ') + ' kilépett.');
      setShowMessage(true);
      setTimeout(() => setShowMessage(false), 3000);
    }

    if (isFirstTime) {
      setIsFirstTime(false);
    }

    setParticipants(identities);
  }, [speakerViewParticipants]);

  return <Snackbar variant="info" headline="" message={participantActivity} open={showMessage} />;
}
